import { useTranslation } from 'react-i18next';

export const DAYS_OF_WEEK = [
  { value: 1, labelKey: 'admin.scheduleEditor.monday' },
  { value: 2, labelKey: 'admin.scheduleEditor.tuesday' },
  { value: 3, labelKey: 'admin.scheduleEditor.wednesday' },
  { value: 4, labelKey: 'admin.scheduleEditor.thursday' },
  { value: 5, labelKey: 'admin.scheduleEditor.friday' },
  { value: 6, labelKey: 'admin.scheduleEditor.saturday' },
  { value: 0, labelKey: 'admin.scheduleEditor.sunday' },
] as const;

export const ALL_DAYS = DAYS_OF_WEEK.map((day) => day.value);

export interface ScheduleValue {
  daysOfWeek: number[];
  enabled: boolean;
}

/** Human-readable state of a schedule, for a summary line or a collapsed accordion header. */
export const useScheduleSummary = (value: ScheduleValue): string => {
  const { t } = useTranslation('admin');

  if (!value.enabled) return t('admin.scheduleEditor.automatedDiscoveryIsCurrentlyDisabled');
  if (value.daysOfWeek.length === ALL_DAYS.length)
    return t('admin.scheduleEditor.runningDailyEveryDayOf');
  if (value.daysOfWeek.length === 0) return '';
  return t('admin.scheduleEditor.runningTimesPerWeek', { count: value.daysOfWeek.length });
};
